"use client"
import { Breadcrumb, BreadcrumbProps } from "antd"
import Link from "next/link"
import React from "react"

type Props = {
    items: {
        name: string
        link: string
    }[]
} & BreadcrumbProps
export function BreadcrumbList({ items, ...props }: Props) {
    return (
        <Breadcrumb {...props}>
            {global?.location?.pathname !== "/" && (
                <Breadcrumb.Item>
                    <Link href={"/"}>Home</Link>
                </Breadcrumb.Item>
            )}
            {items.map((i, k) => {
                return (
                    <Breadcrumb.Item key={k}>
                        <Link as={i.link} href={i.link}>
                            {i.name}
                        </Link>
                    </Breadcrumb.Item>
                )
            })}
        </Breadcrumb>
    )
}
